import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Utils from './utils/utils'
import http from './http'
import VueI18n from 'vue-i18n'
import store from './store/index'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.config.productionTip = false
// Vue.use(ElementUI)
Vue.prototype.utils = Utils
Vue.prototype.$http = http
Vue.prototype.$store = store
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: sessionStorage.lang || 'zh',
  messages: {
    'en':Object.assign(require('./i18n/lang/en'),enLocale),//将我们项目中的语言包与Element的语言包进行合并
    'zh':Object.assign(require('./i18n/lang/zh'),zhLocale),
  }
})
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value) // 在注册Element时设置i18n的处理方法
});

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
